import React from "react";
import "./styles.css";

const SimIcon = ({ isActive, handleClick }) => {
  return (
    <div className="icon-container" id="invite">
      <a className="icon-anchor" onClick={handleClick}>
        <svg
          className="svg-container element-icon"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          xmlnsserif="http://www.serif.com/"
        >
          <g transform="matrix(1.79021,0,0,1.79021,53.7063,19.6923)">
            <circle className={`el-circle ${isActive ? "active" : ""}`} cx="113" cy="132" r="143" />
          </g>

          <g className="el-path" transform="matrix(15.65,0,0,15.65,68.2,68.2)">
            <path d="M8.5,5.5C8.5,5.942 8.582,6.366 8.732,6.755L6.473,8.637C6.164,8.548 5.838,8.5 5.5,8.5C3.567,8.5 2,10.067 2,12C2,13.933 3.567,15.5 5.5,15.5C7.086,15.5 8.425,14.446 8.855,13L15.145,13C15.278,13.447 15.498,13.857 15.786,14.21L14.046,15.66C13.471,15.245 12.764,15 12,15C10.067,15 8.5,16.567 8.5,18.5C8.5,20.433 10.067,22 12,22C13.933,22 15.5,20.433 15.5,18.5C15.5,18.058 15.418,17.635 15.268,17.245L17.527,15.363C17.836,15.452 18.162,15.5 18.5,15.5C20.433,15.5 22,13.933 22,12C22,10.067 20.433,8.5 18.5,8.5C16.915,8.5 15.575,9.554 15.145,11L8.855,11C8.722,10.553 8.502,10.143 8.214,9.79L9.954,8.34C10.53,8.755 11.236,9 12,9C13.933,9 15.5,7.433 15.5,5.5C15.5,3.567 13.933,2 12,2C10.067,2 8.5,3.567 8.5,5.5ZM12,4C11.172,4 10.5,4.672 10.5,5.5C10.5,5.833 10.609,6.141 10.792,6.39C10.798,6.397 10.803,6.403 10.808,6.41C11.082,6.769 11.514,7 12,7C12.828,7 13.5,6.328 13.5,5.5C13.5,4.672 12.828,4 12,4ZM13.194,17.592C13.198,17.597 13.202,17.603 13.206,17.608C13.391,17.858 13.5,18.166 13.5,18.5C13.5,19.328 12.828,20 12,20C11.172,20 10.5,19.328 10.5,18.5C10.5,17.672 11.172,17 12,17C12.487,17 12.92,17.232 13.194,17.592ZM17,12C17,12.828 17.672,13.5 18.5,13.5C19.328,13.5 20,12.828 20,12C20,11.172 19.328,10.5 18.5,10.5C17.672,10.5 17,11.172 17,12ZM5.5,10.5C6.328,10.5 7,11.172 7,12C7,12.828 6.328,13.5 5.5,13.5C4.672,13.5 4,12.828 4,12C4,11.172 4.672,10.5 5.5,10.5Z" />
          </g>
        </svg>
        {!isActive && (
          <div className="tooltip">
            <p>Simulation controls</p>
            <div className="triangle"></div>
          </div>
        )}
        {isActive && <div className="triangle menu"></div>}
      </a>
    </div>
  );
};
export default SimIcon;
